export default {
  "base": "border-s-4 border-(--ui-border-accented) ps-4 italic"
}